import { useRouter } from 'next/router';

export default function CustomRedirect({ to }: { to: string }) {
  const router = useRouter();
  router.replace(to);
  return null;
}
